/* eslint-disable prettier/prettier */
import { TreatyEntityType } from '../../../types/TreatyEntityType';
import { emojiIconMap } from '../../../utils/emojiIconMap';
import { getFieldValue } from '../../../utils/getFieldValue';
import { KeyValuePair } from '../../ui/KeyValuePair';
import { CollapsibleSection } from '../CollapsibleSection';

export const SignaturesSection = ({
  status,
  signatures,
  refreshTreatyData,
}: {
  status: boolean;
  signatures: any[];
  refreshTreatyData?: () => void;
}) => {
  const isMultiple = signatures.length > 1;

  return (
    <CollapsibleSection
      title={isMultiple ? 'Signatures' : 'Signature'}
      icon={emojiIconMap['Signatures']}
    >
      <KeyValuePair label="Status" value={status ? 'Signed' : 'Not signed'} editable={false} />
      <div className="mb-3" />
      {status &&
        (signatures.length === 1
          ? (() => {
              const sig = signatures[0];
              const { value: signatoryValue, ai_result: signatoryAI } = getFieldValue(
                sig.signatory,
              );
              const { value: dateValue, ai_result: dateAI } = getFieldValue(sig.signatureDate);
              const { value: digitalValue, ai_result: digitalAI } = getFieldValue(sig.isDigital);

              return (
                <>
                  <KeyValuePair
                    label="Signatory"
                    value={signatoryValue}
                    aiValue={signatoryAI}
                    entityId={sig?.id}
                    entityType={TreatyEntityType.SIGNATURE}
                    fieldKey="signatory"
                    editable
                    refreshTreatyData={refreshTreatyData}
                  />
                  <KeyValuePair
                    label="Date"
                    value={dateValue}
                    aiValue={dateAI}
                    entityId={sig?.id}
                    entityType={TreatyEntityType.SIGNATURE}
                    fieldKey="signatureDate"
                    editable
                    refreshTreatyData={refreshTreatyData}
                  />
                  <KeyValuePair
                    label="Digital"
                    value={digitalValue}
                    aiValue={digitalAI}
                    entityId={sig?.id}
                    entityType={TreatyEntityType.SIGNATURE}
                    fieldKey="isDigital"
                    editable
                    refreshTreatyData={refreshTreatyData}
                  />
                </>
              );
            })()
          : signatures.map((sig, index) => {
              const { value: signatoryValue, ai_result: signatoryAI } = getFieldValue(
                sig.signatory,
              );
              const { value: dateValue, ai_result: dateAI } = getFieldValue(sig.signatureDate);
              const { value: digitalValue, ai_result: digitalAI } = getFieldValue(sig.isDigital);

              return (
                <CollapsibleSection key={sig?.id || index} title={`Signature ${index + 1}`}>
                  <KeyValuePair
                    label="Signatory"
                    value={signatoryValue}
                    aiValue={signatoryAI}
                    entityId={sig?.id}
                    entityType={TreatyEntityType.SIGNATURE}
                    fieldKey="signatory"
                    editable
                    refreshTreatyData={refreshTreatyData}
                  />
                  <KeyValuePair
                    label="Date"
                    value={dateValue}
                    aiValue={dateAI}
                    entityId={sig?.id}
                    entityType={TreatyEntityType.SIGNATURE}
                    fieldKey="signatureDate"
                    editable
                    refreshTreatyData={refreshTreatyData}
                  />
                  <KeyValuePair
                    label="Digital"
                    value={digitalValue}
                    aiValue={digitalAI}
                    entityId={sig?.id}
                    entityType={TreatyEntityType.SIGNATURE}
                    fieldKey="isDigital"
                    editable
                    refreshTreatyData={refreshTreatyData}
                  />
                </CollapsibleSection>
              );
            }))}
    </CollapsibleSection>
  );
};
